import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
import axios from "axios";
import { useState } from "react";
import LocalSearchData from "../use-local-storage/local-search-data";
import { distance } from "fastest-levenshtein";
export var httpClient = axios.create();
export var localSuggestions = function(searchTerm) {
    var searchTerms = searchTerm.split(/\s+/).filter(Boolean);
    return LocalSearchData.filter(function(data) {
        return searchTerms.some(function(term) {
            var searchTermLength = term.length;
            if (term === data.searchValue.slice(0, Math.max(0, searchTermLength))) return true;
            var ref;
            var levenshtein = distance(term !== null && term !== void 0 ? term : "", (ref = data.searchValue.slice(0, Math.max(0, searchTermLength))) !== null && ref !== void 0 ? ref : "");
            if (searchTermLength > 1 && levenshtein === 1) return true;
            return false;
        });
    });
};
export var useAutoSuggest = function() {
    var searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    var ref = useState("initial"), fetchStatus = ref[0], setFetchStatus = ref[1];
    var ref1 = useState(null), error = ref1[0], setError = ref1[1];
    var ref2 = useState([]), suggestions = ref2[0], setSuggestions = ref2[1];
    var getSuggestionResults = function() {
        var _ref = _async_to_generator(function(value) {
            var size, maxSectionSuggestCount, maxSuggestTotalCount, maxLocalSuggestCount, url, suggestionsResult, error;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        size = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
                        maxSectionSuggestCount = 5;
                        maxSuggestTotalCount = 10;
                        maxLocalSuggestCount = Math.min(maxSectionSuggestCount, localSuggestions(value).length);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setFetchStatus("pending");
                        if (value.length === 0) {
                            setFetchStatus("initial");
                            return [
                                2
                            ];
                        }
                        url = "".concat(searchApiUrl, "/suggest");
                        return [
                            4,
                            httpClient.get("".concat(url, "?searchTerm=").concat(value, "&size=").concat(size))
                        ];
                    case 2:
                        suggestionsResult = _state.sent();
                        setSuggestions([
                            {
                                title: "Make model trim",
                                suggestions: _to_consumable_array(suggestionsResult.data.suggestions).slice(0, maxSuggestTotalCount - maxLocalSuggestCount)
                            },
                            {
                                title: localSuggestions(value).length > 0 ? "Car type" : "",
                                suggestions: _to_consumable_array(localSuggestions(value)).slice(0, maxLocalSuggestCount)
                            }
                        ].filter(Boolean));
                        setFetchStatus("success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setError(error);
                        setFetchStatus("error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSuggestionResults(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearSuggestions = function() {
        setSuggestions([
            {
                title: "Make model trim",
                suggestions: []
            }
        ]);
    };
    return {
        fetchStatus: fetchStatus,
        error: error,
        getSuggestionResults: getSuggestionResults,
        suggestions: suggestions,
        clearSuggestions: clearSuggestions
    };
};
